import DomainMonitorList from '../components/DomainMonitorList.vue';
import DomainMonitorAdd from '../components/DomainMonitorAdd.vue';
import DNSMonitoringHistory from '../components/DNSMonitoringHistory.vue';
import WHOISMonitoringHistory from '../components/WHOISMonitoringHistory.vue';
import SSLMonitoringHistory from '../components/SSLMonitoringHistory.vue';

export default [
  {
    path: '',
    redirect: 'list',
    role: ['User']
  },
  {
    path: 'list',
    component: DomainMonitorList,
    meta: {
      title: 'SSL/Whois/Dns Monitoring',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home',
        },
        {
          path: '/domain-monitoring',
          title: 'SSL/Whois/Dns monitoring',
        },
        {
          path: '',
          title: 'SSL/Whois/Dns Monitoring',
        },
      ],
    },
  },
  {
    path: 'add-domain',
    component: DomainMonitorAdd,
    meta: {
      title: 'Add Configuration',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain-monitoring',
          title: 'SSL/Whois/Dns monitoring'
        },
        {
          path: 'add-domain',
          title: 'Add Configuration'
        }
      ]
    }
  },
  {
    path: ':id/:domain/dns-history',
    component: DNSMonitoringHistory,
    meta: {
      title: 'DNS Monitoring History',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain-monitoring',
          title: 'SSL/Whois/Dns monitoring'
        },
        {
          path: '',
          title: 'DNS Monitoring History'
        }
      ]
    }
  },
  {
    path: ':id/:domain/whois-history',
    component: WHOISMonitoringHistory,
    meta: {
      title: 'Whois Monitoring Hisrory',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain-monitoring',
          title: 'SSL/Whois/Dns monitoring'
        },
        {
          path: '',
          title: 'WHOIS Monitoring History'
        }
      ]
    }
  },
  {
    path: ':id/:domain/ssl-certificate-history',
    component: SSLMonitoringHistory,
    meta: {
      title: 'SSL Certificate Monitoring History',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/domain-monitoring',
          title: 'SSL/Whois/Dns monitoring'
        },
        {
          path: '',
          title: 'SSL Certificate Monitoring History'
        }
      ]
    }
  },
];
